import callApi, { CallApiResult, HttpMethod, Params, RequestHeaders } from 'src/api';

export const fetchActionDTO = (
    method: HttpMethod,
    endpoint?: string,
    data?: any,
    headers?: RequestHeaders,
    params?: Params
): Promise<CallApiResult> => {
    if (!endpoint) return Promise.reject('no endpoint given');

    return callApi(endpoint, { method, data, headers, params });
};
